import React, { createContext, useContext, useEffect, useState, useCallback, useRef } from "react";
import { io } from "socket.io-client";
import { AuthContext } from "./AuthContext";
import axios from "axios";
import { BACKEND_URL } from "../api/api";

const NotificacionContext = createContext();

export const useNotificaciones = () => useContext(NotificacionContext);

export const NotificacionProvider = ({ children }) => {
  const { token, user } = useContext(AuthContext);
  const [solicitudesPendientes, setSolicitudesPendientes] = useState(0);
  const [validacionesPendientes, setValidacionesPendientes] = useState(0);

  const isAdmin = user?.role === "admin" || user?.role === "global_admin";

  // Cargar contadores iniciales por REST
  const fetchCounts = useCallback(async () => {
    if (!token || !isAdmin) return;
    try {
      const res = await axios.get(`${BACKEND_URL}/api/v1/notificaciones/counts`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSolicitudesPendientes(res.data.solicitudesPendientes);
      setValidacionesPendientes(res.data.validacionesPendientes);
    } catch { /* silencioso */ }
  }, [token, isAdmin]);

  useEffect(() => {
    fetchCounts();
  }, [fetchCounts]);

  // Ref para usar fetchCounts dentro del effect sin añadirlo como dependencia
  const fetchCountsRef = useRef(fetchCounts);
  useEffect(() => { fetchCountsRef.current = fetchCounts; }, [fetchCounts]);

  // Conectar socket para actualizaciones en tiempo real
  useEffect(() => {
    if (!token || !isAdmin) return;

    console.log("[NOTIF] Creando socket, token:", token?.substring(0, 20));

    const socket = io(BACKEND_URL, {
      auth: { token },
      transports: ["websocket"],
    });

    // Refrescar contadores al (re)conectar por si se perdieron eventos
    socket.on("connect", () => {
      console.log("[NOTIF] Socket conectado, id:", socket.id, "transport:", socket.io?.engine?.transport?.name);
      fetchCountsRef.current();
    });

    socket.on("solicitudes:count", (count) => {
      console.log("[NOTIF] Recibido solicitudes:count =", count);
      setSolicitudesPendientes(count);
    });

    socket.on("validaciones:count", (count) => {
      console.log("[NOTIF] Recibido validaciones:count =", count);
      setValidacionesPendientes(count);
    });

    // Para global_admin: refrescar contadores cuando llega evento global
    if (user?.role === "global_admin") {
      socket.on("solicitudes:count:global", () => fetchCountsRef.current());
      socket.on("validaciones:count:global", () => fetchCountsRef.current());
    }

    socket.on("connect_error", (err) => {
      console.log("[NOTIF] Socket connect_error:", err.message);
    });

    socket.on("disconnect", (reason) => {
      console.log("[NOTIF] Socket desconectado:", reason);
    });

    return () => {
      console.log("[NOTIF] Limpiando socket");
      socket.disconnect();
    };
  }, [token, isAdmin, user?.role]);

  return (
    <NotificacionContext.Provider value={{ solicitudesPendientes, validacionesPendientes, fetchCounts }}>
      {children}
    </NotificacionContext.Provider>
  );
};
